/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */

export type TipoOlioLubrifica =
  (typeof TipoOlioLubrifica)[keyof typeof TipoOlioLubrifica];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TipoOlioLubrifica = {
  idraulico: "idraulico",
  riduttori: "riduttori",
  turbine: "turbine",
  lubrifica: "lubrifica",
  acquaGlicole: "acquaGlicole",
} as const;
